import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";

const DEFAULT_MAX_LOGIN_ATTEMPTS = 10;
const maxLoginAttemptsFromConfig = Number.parseInt(
  process.env.REACT_APP_MAX_LOGIN_ATTEMPTS,
  10,
);
const maxLoginAttempts =
  Number.isNaN(maxLoginAttemptsFromConfig) || maxLoginAttemptsFromConfig <= 0
    ? DEFAULT_MAX_LOGIN_ATTEMPTS
    : maxLoginAttemptsFromConfig;

const FormLogin = ({
  sendFormLogin,
  loginAttempt,
  resentValidation,
  error,
  loginAttempts,
  loginErrorCode,
  localConfigurator,
  resetLoginError,
}) => {
  const [loginError, setLoginError] = useState(null);

  useEffect(() => {
    if (
      loginAttempts &&
      loginAttempts > 0 &&
      loginErrorCode === "INVALID_LOGIN"
    ) {
      const attempsLeft = maxLoginAttempts - Number(loginAttempts);
      setLoginError(
        `Mot de passe invalide (${attempsLeft} ${attempsLeft > 1 ? "essais restants" : "essai restant"}).`,
      );
    } else if (loginErrorCode === "MAX_LOGIN_ATTEMPTS_REACHED") {
      setLoginError(
        `Compte bloqué. Veuillez contacter ${localConfigurator?.email?.adminContactEmail || "l'administrateur du configurateur"}.`,
      );
    } else if (error) {
      setLoginError(error);
    } else setLoginError(null);
  }, [
    error,
    loginAttempts,
    loginErrorCode,
    localConfigurator,
    resetLoginError,
  ]);

  useEffect(() => {
    return () => {
      resetLoginError();
    };
  }, []); //eslint-disable-line

  return (
    <Formik
      enableReinitialize
      initialValues={{
        email: "",
        password: "",
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
          sendFormLogin(values);
        }, 500);
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().email("Email invalide").required("Champ Requis"),
        password: Yup.string().required("Champ Requis"),
      })}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;

        return (
          <form onSubmit={handleSubmit}>
            <div className="row form-group">
              <div className="col-md-12">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  id="email"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                />
                {errors.email && touched.email && (
                  <div className="error-message danger">{errors.email}</div>
                )}
              </div>
            </div>

            <div className="row form-group">
              <div className="col-md-12">
                <label htmlFor="password">Mot de passe</label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                {errors.password && touched.password && (
                  <div className="error-message danger">{errors.password}</div>
                )}
              </div>
            </div>
            {loginError && (
              <div className="form-group danger darken-1">{loginError}</div>
            )}

            {loginAttempt &&
              loginAttempt.email !== "" &&
              loginAttempt.isVerified === false && (
                <>
                  <div className="form-group danger darken-1">
                    Votre email {loginAttempt.email} n'a pas été activé.
                    <button
                      style={{
                        color: "#9821e8",
                        border: "none",
                        background: "none",
                      }}
                      onClick={resentValidation}
                    >
                      {" "}
                      Cliquer ici{" "}
                    </button>
                    pour renvoyer un email d'activation.
                    <p className="mt-1">
                      <i
                        className="feather icon-alert-triangle danger"
                        style={{ fontSize: "16px", marginRight: "7px" }}
                      />
                      Si vous utilisez un bloqueur de spam, attention de donner
                      l’accès à contact@apsivi.com
                    </p>
                  </div>
                </>
              )}
            {loginAttempt &&
              loginAttempt.email === "" &&
              loginAttempt.isVerified === false && (
                <div className="form-group danger darken-1">Email envoyé.</div>
              )}
            <div className="form-group">
              <input
                type="submit"
                value="Se connecter"
                className="btn btn-primary"
              />
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default FormLogin;
